import { createMemo, createRoot } from "solid-js";

import { CURRENCY_SYMBOL } from "@/constants/constants";
import { isOpenWagerContest } from "@/hooks/useWagerContest";
import { configStore } from "@/stores/configStore";
import { sysConfigStore } from "@/stores/sysConfigStore";
import { getDefaultPointType, userStore } from "@/stores/userStore";
import { CompType } from "@/types/compontent/base/baseEnum";
import { CompLoginStatus, CompRechargeTypes, CompStatus } from "@/types/config";
import { ComponentInfo } from "@/types/swagger/front";

const ComponentTypes = [
  "banner",
  "carousel",
  "game_list",
  "game_entry",
  "guess_you_like",
  "winner",
  "game_nav",
  "bet_game",
  "maker_list",
  "bet_record",
  "policy",
  "media",
  "foot_info",
  "sport",
  "search",
  "custom_list",
  "guess_you_like",
  "promote",
  "seo",
  "stochastic_game",
  "champion_ship",
  "activity_banner",
  "store_download",
  "hot_cold_game",
  "competition",
];

const filterComponentLists = (ComponentLists: ComponentInfo[]) => {
  console.log("filter componentLists: ", ComponentLists);
  return ComponentLists?.filter(
    ({ login_type, type, status, recharge_type }) => {
      const isAllowedType = ComponentTypes.includes(type);
      if (!isAllowedType) return false;
      if (status != CompStatus.open) {
        return false;
      }
      if (type == CompType.bet_game && !isOpenWagerContest()) {
        return false;
      }
      return verifyLoginType(login_type) && verifyPayType(recharge_type);
    },
  );
};

const verifyLoginType = (type: number) => {
  if (type == CompLoginStatus.isLogin && userStore.isLogin) {
    return true;
  } else if (type == CompLoginStatus.noLogin && !userStore.isLogin) {
    return true;
  }
  return type == 1;
};

const verifyPayType = (type: number) => {
  if (type == CompRechargeTypes.isRecharge && userStore.userInfo?.is_pay) {
    return true;
  } else if (
    type == CompRechargeTypes.noRecharge &&
    !userStore.userInfo?.is_pay
  ) {
    return true;
  }
  return type == 1;
};

export enum ComponentKeys {
  HOME = "home",
  CASINO = "casino",
}

export const getIndexComponentLists = createRoot((dispose) => {
  const memo = createMemo(() => {
    const home = configStore.frontCfgMap["pageKeyCfg"]?.["home"] || "home";

    return filterComponentLists(configStore.componentListMap[home] || []);
  });
  return memo;
});

export const getCasinoComponentLists = createRoot((dispose) => {
  const memo = createMemo(() => {
    const casino =
      configStore.frontCfgMap["pageKeyCfg"]?.["casino"] || "casino";
    return filterComponentLists(configStore.componentListMap[casino] || []);
  });
  return memo;
});

// 获取货币配置
export const getCrypto = (pointType: number) => {
  return sysConfigStore.crypto_maps[pointType] || {};
};

//货币符号
export const getCurrencySymbol = createRoot((dispose) => {
  const memo = createMemo(() => {
    return getCrypto(getDefaultPointType())?.symbol || CURRENCY_SYMBOL || "R$";
  });
  return memo;
});
